import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { ModeratorIcon } from '../../components/icons';
import Modal from '../../components/modal';
import Confirmation from '../../components/confirmation';
import PromoteUserDetails from '../promote-user-details';
import { HorizontalSeparator, VerticalSeparator } from '../../components/separator';
import withDeviceType from '../../hoc/with-device-type';
import withTranslate from '../../hoc/with-translate';
import styles from './promote-moderator-modal.scss';

export const PromoteModeratorModal = ({ user, closeModal, promoteModerator, isDesktop, isMobile, t }) =>
  <Modal className={styles.modal} onClose={closeModal}>
    <div className={styles.container}>
      <PromoteUserDetails user={user}/>
      {isMobile && <HorizontalSeparator className={styles.horizontalSeparator}/>}
      {isDesktop && <VerticalSeparator className={styles.verticalSeparator}/>}
      <Confirmation
        icon={ModeratorIcon}
        title={t('promote-moderator-modal.set-as-moderator')}
        confirm={t('promote-moderator-modal.confirm')}
        onConfirm={promoteModerator}
        cancel={t('promote-moderator-modal.cancel')}
        onCancel={closeModal}
      >
        <p>
          {t('promote-moderator-modal.have-access-to-categories')}
        </p>
        <p>
          {t('promote-moderator-modal.what-they-can-do')}
        </p>
        <ul>
          <li>
            {t('promote-moderator-modal.delete-posts')}
          </li>
          <li>
            {t('promote-moderator-modal.disable-commenting')}
          </li>
          <li>
            {t('promote-moderator-modal.move-posts')}
          </li>
        </ul>
      </Confirmation>
    </div>
  </Modal>;

PromoteModeratorModal.propTypes = {
  user: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  promoteModerator: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool,
  isMobile: PropTypes.bool,
  t: PropTypes.func,
};

export default _.flowRight(withDeviceType, withTranslate)(PromoteModeratorModal);



// WEBPACK FOOTER //
// ./app/components/promote-moderator-modal/promote-moderator-modal.js